export const makeCounter = (startValue = 0) => {
  let count = startValue
  function countUp(): number {
    count += 1
    return count
  }
  return countUp
}
